import { css } from '@emotion/react'
import { Theme } from '@mui/material'

type SidebarButtonContainerProps = {
  theme: Theme
  active: boolean
  disabled: boolean
  hidden?: boolean
  displayLabel?: boolean
}

type SidebarMenuItemContainerProps = SidebarButtonContainerProps

export const sidebarMenuItemContainer = ({
  theme,
  active,
  disabled,
  hidden,
}: SidebarMenuItemContainerProps) => css`
  appearance: none;
  -webkit-appearance: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  text-align: inherit;
  line-height: normal;
  outline: none;

  display: flex;
  justify-content: center;
  align-items: ${hidden ? 'flex-end' : 'center'};
  overflow: hidden;

  padding: ${hidden ? 0 : theme.spacing(2)} ${theme.spacing(2)};
  border-radius: ${theme.spacing(1)};
  transform: ${hidden ? 'translateY(4px)' : 'translateX(0)'};
  max-height: ${hidden ? 0 : ''};
  opacity: ${hidden ? 0 : 1};

  transition:
    background-color 0.2s,
    transform 0.4s,
    opacity 0.2s;
  background-color: ${active
    ? theme.palette.white.light
    : disabled
      ? theme.palette.primary.dark
      : 'transparent'};

  &:hover {
    cursor: ${hidden || disabled ? '' : 'pointer'};
    transform: ${!hidden && !disabled && !active && `translateX(4px)`};
  }

  > svg {
    width: ${theme.spacing(7)};
  }

  position: relative;
`

export const sidebarMenuItemLabel = ({
  theme,
  active,
  displayLabel,
  disabled,
}: SidebarMenuItemContainerProps) => css`
  color: ${active ? theme.palette.primary.main : theme.palette.primary.contrastText};
  color: ${disabled && theme.palette.primary.dark};
  white-space: nowrap;
  flex-grow: 1;
  text-align: left;
  width: 0;
  opacity: ${displayLabel ? 1 : '0 !important'};
  transition:
    opacity 0.1s,
    transform 0.2s;
  transform: ${displayLabel ? 'translateX(8px)' : 'translateX(-20px)'};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: start;
`
